import {
  Col,
  FormGroup,
  Label,
  Row,
  InputGroup,
  Card,
  CardTitle,
  CardBody,
} from "reactstrap";
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import CustomSelect from "../../Common/CustomSelect";
import { AvField } from "availity-reactstrap-validation";
import CustomMultipleDateRange from "../../CustomMultipleDateRange/CustomMultipleDateRange";
import { getCurrentDay } from "../../../helpers/utils";
import axios from "axios";
import CheckboxCollapse from '../../Common/CheckboxCollapse';
// import jsPDF from "jspdf";
// import autoTable from 'jspdf-autotable';
import InvoiceTemplate1 from '../../../pages/Accounting/Invoices/InvoicesProfile/components/template1';
import InvoiceTemplate2 from '../../../pages/Accounting/Invoices/InvoicesProfile/components/template2';
import InvoiceTemplate3 from '../../../pages/Accounting/Invoices/InvoicesProfile/components/template3';

const TYPES = [
  {
    label: "By day",
    value: "day"
  },
  {
    label: "Date range",
    value: "range"
  }
]

const InvoiceByOffer = props => {
  const [selectedPosition, setSelectedPosition] = React.useState(null);
  const [selectedBonus, setSelectedBonus] = React.useState(null);
  const [legalEntityData, setLegalEntityData] = React.useState([]);
  const [legalEntity, setLegalEntity] = React.useState(null);
  const [invoiceTemplate, setInvoiceTemplate] = React.useState(null);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [selectedBankDetails, setSelectedBankDetails] = React.useState(null);

  const [clearedRange, setClearedRange] = React.useState(false);
  const [selectedDateType, setSelectedDateType] = React.useState(TYPES[0]);
  const [date, setDate] = React.useState()

  const [isVoucherCurrency, setIsVoucherCurrency] = React.useState(false);
  const [isUsedTemplate, setIsUsedTemplate] = React.useState(false);

  const [course, setCourse] = React.useState(0);

  let defDataForTemplates = {
    "demo": true,
    "classification": "CUSTOM",
    "notCustomColls": [
      {
        "Header": isVoucherCurrency ? "Опис" : "Type",
        "accessor": "type",
        "style": {
          "textAlign": "center",
          "width": "auto",
          "verticalAlign": "middle"
        }
      },
      {
        "Header": isVoucherCurrency ? "Кількість годин" : "Period",
        "accessor": "period",
        "style": {
          "textAlign": "center",
          "width": "30%",
          "verticalAlign": "middle"
        }
      },
      {
        "Header": isVoucherCurrency ? "Сума" : "Amount",
        "accessor": "total",
        "style": {
          "textAlign": "center",
          "width": "30%",
          "verticalAlign": "middle"
        }
      }
    ],
    "ClientColls": [
      {
        "Header": isVoucherCurrency ? "Опис" : "Type",
        "accessor": "title",
        "style": {
          "textAlign": "center",
          "width": "auto",
          "verticalAlign": "middle"
        }
      },
      {
        "Header": isVoucherCurrency ? "Кількість годин" : "Period",
        "style": {
          "textAlign": "center",
          "width": "30%",
          "verticalAlign": "middle"
        }
      },
      {
        "Header": isVoucherCurrency ? "Сума" : "Amount",
        "accessor": "custom_unit_price",
        "style": {
          "textAlign": "center",
          "width": "30%",
          "verticalAlign": "middle"
        }
      }
    ],
    "total_in_custom_currency": isVoucherCurrency ? "100 UAH" : "100 USD",
    "invoiceData": {
      "id": 318,
      "items": [
        {
          "id": 711,
          "title": isVoucherCurrency ? "Надані послуги. Без ПДВ" : "Services provided. Excluding VAT",
          "quantity": "1.000",
          "unit": "PIECES",
          "unit_price": "100",
          "custom_unit_price": isVoucherCurrency ? "100 UAH" : "100 USD",
          "discount": "0.0",
          "tax_rate": null,
          "tag": null,
          "weight": 0,
          "date_from": "2024-01-01",
          "date_to": "2024-01-31",
          "created": "2024-02-13T11:02:59.374629Z",
          "modified": "2024-02-13T11:02:59.374653Z",
          "invoice": 318
        }
      ],
      "total_in_custom_currency": isVoucherCurrency ? "100 UAH" : "100 USD",
      "type": "INVOICE",
      "classification": "CUSTOM",
      "sequence": 25,
      "number": "1",
      "status": "NEW",
      "language": "ru",
      "date_issue": "2024-02-13",
      "date_tax_point": "2024-02-13",
      "date_due": "2024-02-29",
      "currency": isVoucherCurrency ? "UAH" : "USD",
      "currency_value": "37.87",
      "total_in_the_selected_currency": "100",
      "credit": "0.00",
      "payment_method": "BANK_TRANSFER",
      "bank_name": isVoucherCurrency ? "АТ ВТ \"БАНК\"" : "AT BT \"BANK NAME\"",
      "bank_street": isVoucherCurrency ? "Україна, 00000, м. Київ, Вулиця" : "Ukraine, 00000, Kyiv, Lights Street, 1D",
      "bank_account_number": "UA000000000000000000000000000",
      "supplier_bank_correspondents": "[]",
      "supplier_name": isVoucherCurrency ? "ФОП Назва Постачальника" : "FOP Supplier Name",
      "supplier_street": isVoucherCurrency ? "Україна, 11111, м. Київ, Вулиця Постачальник, 1Д" : "Ukraine, 11111, Kyiv, Supplier Street, 1A",
      "supplier_signer": isVoucherCurrency ? "Постачальник Ім\'я Підписанта" : "Supplier Signer Name",
      "customer_name": isVoucherCurrency ? "АТ \"БАНК\"" : "AT \"BANK\"",
      "customer_street": isVoucherCurrency ? "44444, м. Київ, Вулиця, 1А" : "44444, Kyiv, Avrage Street, 54/19",
      "delivery_method": "PERSONAL_PICKUP",
      "payment_description": isVoucherCurrency ? "Надані послуги" : "Services provided",
      "period": "2024-01-01 - 2024-01-31",
      "date_from": "2024-01-01",
      "date_to": "2024-01-31",
    },
    "base64Image": "",
    "langUA": isVoucherCurrency
  }

  // React.useEffect(() => {
  //   const doc = new jsPDF();

  //   doc.setFont('sans-serif', 'normal');
  //   // 'Poppins', 'sans-serif'

  //   autoTable(doc, {
  //     body: [
  //       [
  //         {
  //           content: 'Афф Hell',
  //           styles: {
  //             halign: 'left',
  //             fontSize: 20,
  //             textColor: '#000',
  //             // font: "Poppins"
  //           }
  //         },
  //         {
  //           content: 'Афф Hell',
  //           styles: {
  //             halign: 'left',
  //             fontSize: 20,
  //             textColor: '#000',
  //             // font: "Poppins"
  //           }
  //         },
  //         {
  //           content: 'Афф Hell',
  //           styles: {
  //             halign: 'left',
  //             fontSize: 20,
  //             textColor: '#000',
  //             font: "courier"
  //           }
  //         },
  //         // {
  //         //   content: 'Invoice',
  //         //   styles: {
  //         //     halign: 'right',
  //         //     fontSize: 20,
  //         //     textColor: '#ffffff'
  //         //   }
  //         // }
  //       ],
  //     ],
  //     theme: 'plain',
  //     styles: {
  //       // fillColor: '#3366ff'
  //     }
  //   });

  //   autoTable(doc, {
  //     body: [
  //       [
  //         {
  //           content: 'Reference: #INV0001'
  //             + '\nDate: 2022-01-27'
  //             + '\nInvoice number: 123456',
  //           styles: {
  //             halign: 'right'
  //           }
  //         }
  //       ],
  //     ],
  //     theme: 'plain'
  //   });

  //   autoTable(doc, {
  //     body: [
  //       [
  //         {
  //           content: 'Billed to:'
  //             + '\nJohn Doe'
  //             + '\nBilling Address line 1'
  //             + '\nBilling Address line 2'
  //             + '\nZip code - City'
  //             + '\nCountry',
  //           styles: {
  //             halign: 'left'
  //           }
  //         },
  //         {
  //           content: 'Shipping address:'
  //             + '\nJohn Doe'
  //             + '\nShipping Address line 1'
  //             + '\nShipping Address line 2'
  //             + '\nZip code - City'
  //             + '\nCountry',
  //           styles: {
  //             halign: 'left'
  //           }
  //         },
  //         {
  //           content: 'From:'
  //             + '\nCompany name'
  //             + '\nShipping Address line 1'
  //             + '\nShipping Address line 2'
  //             + '\nZip code - City'
  //             + '\nCountry',
  //           styles: {
  //             halign: 'right'
  //           }
  //         }
  //       ],
  //     ],
  //     theme: 'plain'
  //   });

  //   autoTable(doc, {
  //     body: [
  //       [
  //         {
  //           content: 'Amount due:',
  //           styles: {
  //             halign: 'right',
  //             fontSize: 14
  //           }
  //         }
  //       ],
  //       [
  //         {
  //           content: '$4000',
  //           styles: {
  //             halign: 'right',
  //             fontSize: 20,
  //             textColor: '#3366ff'
  //           }
  //         }
  //       ],
  //       [
  //         {
  //           content: 'Due date: 2022-02-01',
  //           styles: {
  //             halign: 'right'
  //           }
  //         }
  //       ]
  //     ],
  //     theme: 'plain'
  //   });

  //   autoTable(doc, {
  //     body: [
  //       [
  //         {
  //           content: 'Products & Services',
  //           styles: {
  //             halign: 'left',
  //             fontSize: 14
  //           }
  //         }
  //       ]
  //     ],
  //     theme: 'plain'
  //   });

  //   autoTable(doc, {
  //     head: [['Items', 'Category', 'Quantity', 'Price', 'Tax', 'Amount']],
  //     body: [
  //       ['Product or service name', 'Category', '2', '$450', '$50', '$1000'],
  //       ['Product or service name', 'Category', '2', '$450', '$50', '$1000'],
  //       ['Product or service name', 'Category', '2', '$450', '$50', '$1000'],
  //       ['Product or service name', 'Category', '2', '$450', '$50', '$1000']
  //     ],
  //     theme: 'striped',
  //     headStyles: {
  //       fillColor: '#343a40'
  //     }
  //   });

  //   autoTable(doc, {
  //     body: [
  //       [
  //         {
  //           content: 'Subtotal:',
  //           styles: {
  //             halign: 'right'
  //           }
  //         },
  //         {
  //           content: '$3600',
  //           styles: {
  //             halign: 'right'
  //           }
  //         },
  //       ],
  //       [
  //         {
  //           content: 'Total tax:',
  //           styles: {
  //             halign: 'right'
  //           }
  //         },
  //         {
  //           content: '$400',
  //           styles: {
  //             halign: 'right'
  //           }
  //         },
  //       ],
  //       [
  //         {
  //           content: 'Total amount:',
  //           styles: {
  //             halign: 'right'
  //           }
  //         },
  //         {
  //           content: '$4000',
  //           styles: {
  //             halign: 'right'
  //           }
  //         },
  //       ],
  //     ],
  //     theme: 'plain'
  //   });

  //   autoTable(doc, {
  //     body: [
  //       [
  //         {
  //           content: 'Terms & notes',
  //           styles: {
  //             halign: 'left',
  //             fontSize: 14
  //           }
  //         }
  //       ],
  //       [
  //         {
  //           content: 'orem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia'
  //             + 'molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum'
  //             + 'numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium',
  //           styles: {
  //             halign: 'left'
  //           }
  //         }
  //       ],
  //     ],
  //     theme: "plain"
  //   });

  //   autoTable(doc, {
  //     body: [
  //       [
  //         {
  //           content: 'This is a centered footer',
  //           styles: {
  //             halign: 'center'
  //           }
  //         }
  //       ]
  //     ],
  //     theme: "plain"
  //   });

  //   // doc.save("invoice")
  // }, []);

  const getValDollar = async (date) => {
    if (date) {
      let params = {
        start_date: date?.start_date.replace(/-/g, ''),
        end_date: date?.end_date ? date.end_date.replace(/-/g, '') : date?.start_date.replace(/-/g, '')
      } ///api/bank/v1
      // for local http://localhost:8010/proxy/-path-
      axios.get(`/api/express/proxy/bank/NBU_Exchange/exchange_site?start=${params.start_date}&end=${params.end_date}&valcode=usd&order=desc&json`)
        .then(({ data }) => {
          if (selectedDateType.value === 'range') {
            const rates = data.map(item => item.rate);
            const sum = rates.reduce((acc, rate) => acc + rate, 0);
            const average = sum / data.length;
            setCourse(Number(average.toFixed(4)))
          } else {
            setCourse(data[0].rate)
          }
        })
        .catch(error => console.error('Error:', error));
    }
  }

  React.useEffect(() => {
    if (!clearedRange) {
      setClearedRange(true)
    }
  }, [selectedDateType])

  React.useEffect(() => {
    let entityData = [];
    props.legal_entity.map(i => {
      entityData.push({
        label: i.counterparty_name,
        value: i.id,
      });
    });
    setLegalEntityData(entityData);
  }, [props.legal_entity]);

  React.useEffect(() => {
    if (selectedPosition !== null) {
      setSelectedUser(null);
      setLegalEntity(null);
      setInvoiceTemplate(null);
      setSelectedBankDetails(null)
      props.onGetUsersByPosition(selectedPosition.value);
    }
  }, [selectedPosition]);

  React.useEffect(() => {
    setInvoiceTemplate(null);
  }, [isUsedTemplate])

  const onChangeClear = () => {
    setClearedRange(false);
  }

  const selectUserProfile = data => {
    if (data?.label) {
      setSelectedBankDetails(null)
      setSelectedUser(data);
      // let idx = props.users.findIndex(i => i.id === data.value);
      selectedUser?.value != data.value && props.getBankDetailsForUser(data.value)
    }
  };

  const getBonuses = (data) => {
    let bonuses = data.map((i) => {
      return {
        label: i.name,
        value: i.id
      }
    })
    // { label: 'Without a bonus', value: "null" },
    return [...bonuses]
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="h4 mb-4">Salary</CardTitle>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Position:</Label>
                <CustomSelect
                  // name="position_id"
                  options={
                    props.positions.map(i => {
                      return {
                        label: i.title,
                        value: i.id,
                      };
                    }) || []
                  }
                  placeholder="Select position..."
                  defaultValue={selectedPosition}
                  onChange={item => setSelectedPosition(item)}
                  classNamePrefix="select2-selection"
                  errorMessage="Position is required!"
                  required
                  isFormSubmit={props.isFormSubmit}
                />
              </FormGroup>
            </Col>
            <Col md={6} className={`${selectedPosition !== null && selectedPosition !== "" ? "" : "d-none"
              } fade-in-custom-animate`}>
              <FormGroup className="mb-3">
                <Label htmlFor="">User:</Label>
                <CustomSelect
                  name="user_id"
                  options={props.users.map(i => {
                    return {
                      label: `${i.first_name} ${i.last_name}`,
                      value: i.id,
                    };
                  })}
                  placeholder="Select user..."
                  defaultValue={selectedUser}
                  onChange={e => selectUserProfile(e)}
                  classNamePrefix="select2-selection"
                  errorMessage="User is required!"
                  isLoading={props.users_loading}
                  isFormSubmit={props.isFormSubmit}
                  required
                />
              </FormGroup>
            </Col>

            <Col md={6} className={`${selectedUser !== null && selectedUser !== "" ? "" : "d-none"
              } fade-in-custom-animate`}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Bank details:</Label>
                <CustomSelect
                  name="bank_details_id"
                  options={props.bankDetails?.results ? props.bankDetails.results.map(i => {
                    return {
                      label: `${i.name_of_the_bank}`,
                      value: i.id,
                    };
                  }) : []}
                  placeholder="Select user bank details..."
                  defaultValue={selectedBankDetails}
                  onChange={e => setSelectedBankDetails(e)}
                  classNamePrefix="select2-selection"
                  errorMessage="User bank details is required!"
                  isLoading={props.loading_details}
                  isFormSubmit={props.isFormSubmit}
                  required
                />
              </FormGroup>
            </Col>

            <Col md={6} className={`${selectedUser !== null && selectedUser !== "" ? "" : "d-none"
              } fade-in-custom-animate`}>
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Bonus:</Label>
                <CustomSelect
                  name="bonus_ids"
                  options={props.bonuses?.results ? getBonuses(props.bonuses?.results) : []}
                  placeholder="Select bonus..."
                  // value={selectedBonus}
                  defaultValue={selectedBonus}
                  onChange={item => setSelectedBonus(item)}
                  classNamePrefix="select2-selection"
                  isMulti
                />
              </FormGroup>
            </Col>

            <Col sm={6} lg={6} xl={6} className={`${selectedUser !== null && selectedUser !== "" ? "" : "d-none"
              } fade-in-custom-animate`}>
              <FormGroup className="mb-3">
                <Label htmlFor="">Legal entity:</Label>
                <CustomSelect
                  name="legal_entity_id"
                  options={legalEntityData}
                  placeholder="Select legal entity..."
                  defaultValue={legalEntity}
                  onChange={setLegalEntity}
                  classNamePrefix="select2-selection"
                  errorMessage="Legal entity is required!"
                  isLoading={props.legal_entity_loader}
                  isFormSubmit={props.isFormSubmit}
                  required
                />
              </FormGroup>
            </Col>
            <Col sm={6} lg={6} xl={6} className={`${selectedUser !== null && selectedUser !== "" ? "" : "d-none"
              } fade-in-custom-animate`}>
              <PickerStyled>
                <Label htmlFor="">Date:</Label>
                <FormGroup className="mb-3">
                  <CustomMultipleDateRange
                    placeholder="Select date..."
                    name="month"
                    defaultValue={getCurrentDay}
                    datePickerType={"calendar-with-static"}
                    errorText="Date is required!"
                    onChange={e => setDate(e)}
                    required
                  />
                </FormGroup>
              </PickerStyled>
            </Col>
            <Row>
              <Col sm={12} className={`${selectedUser !== null && selectedUser !== "" ? "" : "d-none"
                } fade-in-custom-animate mb-3`}>
                <FormGroup>
                  <CheckboxCollapse
                    id={"voucher-currency-value"}
                    title="Create in UAH"
                    defaultChecked={isVoucherCurrency}
                    onChange={() => setIsVoucherCurrency(!isVoucherCurrency)}
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    {isVoucherCurrency && (
                      <Row>
                        <Col lg={12} xl={3} className="mb-3">
                          <Label htmlFor="">Currency type:</Label>
                          <CustomSelect
                            options={TYPES}
                            classNamePrefix="select2-selection"
                            defaultValue={selectedDateType}
                            onChange={setSelectedDateType}
                          />
                        </Col>
                        <Col lg={12} xl={4}>
                          <PickerStyled>
                            {selectedDateType.value === 'range' ? (
                              <Label htmlFor="">Date range:</Label>
                            ) : (
                              <Label htmlFor="">Date:</Label>
                            )}
                            <FormGroup className="mb-3">
                              <CustomMultipleDateRange
                                name={`salary-date-` + selectedDateType.value === 'range' ? 'range' : 'calendar'}
                                placeholder={selectedDateType.value === 'range' ? 'Select date range...' : 'Select date...'}
                                datePickerType={selectedDateType.value === 'range' ? 'round' : 'calendar'}
                                onChange={(date) => getValDollar(date)}
                                maxDate={getCurrentDay()}
                                clearedRange={clearedRange}
                                onChangeClearDate={onChangeClear}
                                required
                                errorText="Date is required!"
                              />
                            </FormGroup>
                          </PickerStyled>
                        </Col>
                        <Col className="d-none">
                          <AvField
                            name={`currency`}
                            placeholder="Currency..."
                            type="text"
                            value={"UAH"}
                            className="form-control"
                          />
                          <AvField
                            name={`currency_value`}
                            placeholder="Currency value..."
                            type="number"
                            value={course}
                            className="form-control"
                          />
                        </Col>
                      </Row>
                    )}
                  </CheckboxCollapse>
                </FormGroup>
              </Col>
              <Col sm={12} className={`${selectedUser !== null && selectedUser !== "" ? "" : "d-none"
                } fade-in-custom-animate mb-3`}>
                <FormGroup>
                  <CheckboxCollapse
                    id={"invoice-template-value"}
                    title="Use invoice template"
                    defaultChecked={isUsedTemplate}
                    onChange={() => setIsUsedTemplate(!isUsedTemplate)}
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    {isUsedTemplate && (
                      <Row>
                        <Col lg={12} xl={6} className="mb-3">
                          <Label htmlFor="">Invoice template:</Label>
                          <CustomSelect
                            name="template_id"
                            options={props.invoice_templates.length > 0 ? props.invoice_templates.map(i => {
                              return {
                                label: i.name,
                                value: i.id,
                                data: i.data
                              }
                            }) : []}
                            placeholder="Select invoice template..."
                            defaultValue={invoiceTemplate}
                            onChange={setInvoiceTemplate}
                            classNamePrefix="select2-selection"
                            errorMessage="Template is required!"
                            isLoading={props.invoice_templates_loading}
                            isFormSubmit={props.isFormSubmit}
                            required
                          />
                        </Col>
                        <Col sm={12}>
                          {invoiceTemplate?.data?.template == "14" && (
                            <TemplateDiv>

                              <InvoiceTemplate1
                                {...defDataForTemplates}
                                valuesTemplate={invoiceTemplate?.data || {}}
                                demo
                              />
                            </TemplateDiv>
                          )}
                          {invoiceTemplate?.data?.template == "15" && (
                            <TemplateDiv>

                              <InvoiceTemplate2
                                {...defDataForTemplates}
                                valuesTemplate={invoiceTemplate?.data || {}}
                                demo
                              />
                            </TemplateDiv>
                          )}
                          {invoiceTemplate?.data?.template == "16" && (
                            <TemplateDiv>
                              <InvoiceTemplate3
                                {...defDataForTemplates}
                                valuesTemplate={invoiceTemplate?.data || {}}
                                demo
                              />
                            </TemplateDiv>
                          )}
                        </Col>
                      </Row>
                    )}
                  </CheckboxCollapse>
                </FormGroup>
              </Col>
            </Row>
            <Row>

            </Row>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment >
  );
};

const TemplateDiv = styled.div`
  border: 1px solid rgba(102, 102, 130, 0.4);
  border-radius: 5px;
    padding: 20px;
`;

const PickerStyled = styled(InputGroup)`
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }
`;

InvoiceByOffer.propTypes = {
  positions: PropTypes.arrayOf(PropTypes.object).isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  legal_entity: PropTypes.arrayOf(PropTypes.object).isRequired,
  positions_loading: PropTypes.bool.isRequired,
  isFormSubmit: PropTypes.bool.isRequired,
  legal_entity_loader: PropTypes.bool.isRequired,
  users_loading: PropTypes.bool.isRequired,
  onGetUsersByPosition: PropTypes.func.isRequired,
  bonuses: PropTypes.any.isRequired,
  bonuses_loader: PropTypes.bool.isRequired,
  invoice_templates: PropTypes.object,
  invoice_templates_loading: PropTypes.bool.isRequired,
  getBankDetailsForUser: PropTypes.func.isRequired,
  bankDetails: PropTypes.object.isRequired,
  loading_details: PropTypes.bool.isRequired,
};

export default InvoiceByOffer;
